import Flickity from "flickity";

export default function Contentgalleryblock() {
  Alpine.data("contentgalleryblock", () => ({
    _flkty: null,
    canPrev: false,
    canNext: true,
    activeCaption: "",

    init() {
      const track = this.$el.querySelector("[data-track]");
      if (!track) return;

      const cells = [...track.querySelectorAll("[data-caption]")];
      const captions = cells.map((el) => el.dataset.caption || "");
      this.activeCaption = captions[0] || "";

      requestAnimationFrame(() => {
        this._flkty = new Flickity(track, {
          cellAlign: "left",
          contain: true,
          wrapAround: false,
          pageDots: false,
          prevNextButtons: false,
          draggable: true,
        });

        const updateNav = () => {
          this.canPrev = this._flkty.selectedIndex > 0;
          this.canNext =
            this._flkty.selectedIndex < this._flkty.slides.length - 1;
          this.activeCaption = captions[this._flkty.selectedIndex] || "";
        };

        this._flkty.on("change", updateNav);
        updateNav();

        this._flkty.on("dragStart", () =>
          this._flkty.slider.childNodes.forEach(
            (slide) => (slide.style.pointerEvents = "none"),
          ),
        );
        this._flkty.on("dragEnd", () =>
          this._flkty.slider.childNodes.forEach(
            (slide) => (slide.style.pointerEvents = "all"),
          ),
        );
      });
    },

    destroy() {
      if (this._flkty) {
        this._flkty.destroy();
        this._flkty = null;
      }
    },

    prev() {
      if (this._flkty) this._flkty.previous();
    },

    next() {
      if (this._flkty) this._flkty.next();
    },
  }));
}
